import PropTypes from 'prop-types';
import React, { Component } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classNames from 'classnames';
import { CARD_SIZE_SMALL, CARD_SIZE_MEDIUM, CARD_SIZE_LARGE } from '../../constants/card-sizes';
import PostListClassicHeader from '../post-list-classic-header';
import PostListItemClassic from '../post-list-item-classic';
import CreatePostButton from '../create-post-button';
import { HorizontalSeparator } from '../../components/separator';
import { PaginationClassic } from '../pagination';
import withCardBorderWidth from '../../hoc/with-card-border-width';
import withFontClassName from '../../hoc/with-font-class-name';
import withTranslate from '../../hoc/with-translate';
import Loader from '../../components/loader';
import { changePage } from '../../actions/change-page';
import { POSTS_PER_PAGE } from '../../constants/pagination';
import styles from './post-list-classic.scss';

const TYPES = {
  [CARD_SIZE_SMALL]: 'small',
  [CARD_SIZE_MEDIUM]: 'medium',
  [CARD_SIZE_LARGE]: 'large',
};

class PostListClassic extends Component {
  renderCreateNewPostButton() {
    const { category, showCreatePostAction } = this.props;
    return (
      showCreatePostAction &&
      <div className={styles.buttonContainer}>
        <CreatePostButton categorySlug={category.slug}/>
      </div>
    );
  }

  renderPagination() {
    return (
      <div className={styles.paginationContainer}>
        <PaginationClassic
          page={this.props.page}
          entityCount={this.props.entityCount}
          showPerPage={POSTS_PER_PAGE}
          onChange={this.handlePageChange}
        />
      </div>
    );
  }

  hasControls() {
    const { entityCount, showCreatePostAction } = this.props;
    const hasPages = entityCount > POSTS_PER_PAGE;
    return showCreatePostAction || hasPages;
  }

  renderControls() {
    return (
      <div className={classNames(styles.controls, styles.spacing)}>
        {this.renderPagination()}
        {this.renderCreateNewPostButton()}
      </div>
    );
  }

  handlePageChange = ({ page, buttonType }) => {
    this.props.changePage({
      page,
      meta: {
        bi: {
          buttonType,
        },
      },
    });
    this.props.onPageChange(page);
  };

  renderSeparator(key = 'separator') {
    return (
      <tr key={key}>
        <td className={styles.separatorColumn} colSpan="100">
          <HorizontalSeparator/>
        </td>
      </tr>
    );
  }

  renderTable() {
    const { posts, query, cardSize, onLikeClick } = this.props;
    const type = TYPES[cardSize];
    const hasControls = this.hasControls();

    return (
      <div className={styles.spacing}>
        <table className={classNames(styles.table, { [styles.single]: !hasControls })}>
          <PostListClassicHeader/>
          <tbody>
            {posts.map(post => [
              this.renderSeparator(`separator-${post._id}`),
              <PostListItemClassic key={post._id} type={type} post={post} query={query} onLikeClick={onLikeClick}/>,
            ])}
          </tbody>
        </table>
      </div>
    );
  }

  render() {
    const { isLoading, cardSize, borderWidth, contentFontClassName, isLoaded } = this.props;
    const type = TYPES[cardSize];
    const className = classNames(
      styles.container,
      styles[type],
      'forum-card-background-color',
      'forum-card-border-color',
      contentFontClassName
    );
    const hasControls = this.hasControls();

    return (
      <div className={className} style={{ borderWidth }} data-hook="post-list">
        {hasControls && isLoaded && this.renderControls()}
        {hasControls && <HorizontalSeparator/>}
        {isLoading ? <Loader/> : this.renderTable()}
        {hasControls && <HorizontalSeparator/>}
        {hasControls && isLoaded && this.renderControls()}
      </div>
    );
  }
}

PostListClassic.propTypes = {
  onLikeClick: PropTypes.func.isRequired,
  category: PropTypes.object,
  posts: PropTypes.array,
  query: PropTypes.string,
  cardSize: PropTypes.number,
  page: PropTypes.number,
  entityCount: PropTypes.number,
  borderWidth: PropTypes.number.isRequired,
  contentFontClassName: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
  changePage: PropTypes.func.isRequired,
  showCreatePostAction: PropTypes.bool,
  onPageChange: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  isLoaded: PropTypes.bool,
};

PostListClassic.defaultProps = {
  cardSize: CARD_SIZE_SMALL,
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      changePage,
    },
    dispatch
  );

export default _.flowRight(
  connect(undefined, mapDispatchToProps),
  withCardBorderWidth,
  withFontClassName,
  withTranslate
)(PostListClassic);



// WEBPACK FOOTER //
// ./app/components/post-list/post-list-classic.js